/* GEMIGNIS · tema "La Calle + Rayos X" — comportamiento de la web.
   Es el <script> de demo-web/portada.html (v7) pasado a tema: mismas cuentas y mismos tiempos, pero los datos
   (tiendas, precios, posiciones) ya vienen en el HTML que pinta Liquid, no en arrays de JavaScript.
   Cambios respecto a la maqueta (necesarios en una tienda real):
   - Al "entrar" en una tienda: zoom en la foto y se abre su página de producto real (transición entre páginas).
   - Día/Noche: se recuerda la elección del visitante (localStorage, opcional).
   - Se reinicia solo cuando el editor de temas recarga una sección (shopify:section:load). */
(() => {
  const W = window.WEB || {}, T = W.t || {};
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const loc = W.locale || document.documentElement.lang || 'es';
  const fmt = (n, d = 1) => n.toLocaleString(loc, { minimumFractionDigits: d, maximumFractionDigits: d });
  const vt = fn => (document.startViewTransition && !reduce) ? document.startViewTransition(fn) : fn();
  const root = document.documentElement, sysDark = matchMedia('(prefers-color-scheme: dark)');
  const isNight = () => (root.dataset.theme || (sysDark.matches ? 'dark' : 'light')) === 'dark';
  const onLoad = fn => (document.readyState === 'complete' ? fn() : addEventListener('load', fn, { once: true }));

  let tt;
  function toast(msg) { const t = $('#toast'); if (!t) return; t.textContent = msg; t.hidden = false; clearTimeout(tt); tt = setTimeout(() => t.hidden = true, 2800); }

  // ---------- LA CALLE ----------
  let street = null;
  function initStreet() {
    const canvas = $('#canvas'); if (!canvas) return null;
    const box = canvas.closest('[data-calle]'), scroller = $('#scroller'), slicesEl = $('#slices'), dotsEl = $('#dots');
    let IM; try { IM = JSON.parse(box.dataset.imgs); } catch (_) { return null; }
    const srcset = k => `${k[0]} 1600w, ${k[1]} 2400w`;
    const slices = [...slicesEl.children], hots = $$('.hot', $('#hots'));
    const num = (el, n) => parseFloat(el.style.getPropertyValue('--' + n)) || 0;
    const signOf = id => $(`.signtext[data-id="${id}"]`, box);
    new MutationObserver(() => slices.forEach(sl => signOf(sl.dataset.id)?.classList.toggle('on', sl.classList.contains('on')))).observe(slicesEl, { subtree: true, attributes: true, attributeFilter: ['class'] });
    const sliceOf = id => slices.find(x => x.dataset.id === id);
    let litLoaded = false;
    function setStreet(night) {
      const k = night ? IM.night : IM.day;
      const base = $('#base'), dark = $('#base-src-dark');
      if (dark) dark.srcset = srcset(k.base);
      base.srcset = srcset(k.base); base.src = k.base[0];
      if (litLoaded) slices.forEach(sl => { const im = sl.querySelector('img'); im.srcset = srcset(k.lit); im.sizes = base.sizes; });
      slices.forEach(sl => sl.classList.remove('on'));
      if (litLoaded) wave(night);
    }
    // Las imágenes "encendidas" se cargan después de la primera pintura (no frenan la portada)
    function loadLit() {
      if (litLoaded || !slices.length) return; litLoaded = true;
      const k = isNight() ? IM.night : IM.day;
      slices.forEach(sl => { const im = sl.querySelector('img'); im.sizes = $('#base').sizes; im.srcset = srcset(k.lit); });
      slices[0].querySelector('img').addEventListener('load', () => wave(isNight()), { once: true });
    }
    // Ola de luces: de noche se quedan encendidas; de día se apagan (invitan a pasar el ratón)
    let waveT = [];
    function wave(night) {
      waveT.forEach(clearTimeout); waveT = [];
      slices.forEach((sl, i) => {
        waveT.push(setTimeout(() => sl.classList.add('on'), reduce ? 0 : 250 + i * 260));
        // de día se apaga, salvo la tienda que tiene el ratón o el foco encima (si no, la ola la apagaba)
        if (!night) waveT.push(setTimeout(() => { if (!hots.some(h => h.dataset.id === sl.dataset.id && h.matches(':hover, :focus'))) sl.classList.remove('on'); }, reduce ? 0 : 1200 + i * 260));
      });
    }
    onLoad(() => (window.requestIdleCallback || setTimeout)(loadLit, { timeout: 1200 }));

    // Ratón: la tienda se ilumina y la foto se mueve un poco (sensación de mirar la maqueta)
    const fine = matchMedia('(pointer:fine) and (min-width:761px)');
    hots.forEach(h => {
      const on = () => { if (!isNight()) sliceOf(h.dataset.id)?.classList.add('on'); };
      const off = () => { if (!isNight()) sliceOf(h.dataset.id)?.classList.remove('on'); };
      h.addEventListener('pointerenter', on); h.addEventListener('focus', on);
      h.addEventListener('pointerleave', off); h.addEventListener('blur', off);
    });
    if (!reduce) {
      let raf = 0;
      canvas.addEventListener('pointermove', e => {
        if (!fine.matches) return;
        const r = canvas.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        canvas.classList.add('is-tracking'); cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => { canvas.style.setProperty('--tx', `${(-x * 1.0).toFixed(2)}%`); canvas.style.setProperty('--ty', `${(-y * 0.8).toFixed(2)}%`); });
      });
      canvas.addEventListener('pointerleave', () => { canvas.classList.remove('is-tracking'); canvas.style.setProperty('--tx', '0%'); canvas.style.setProperty('--ty', '0%'); });
    }
    // Móvil: la tienda activa sale de cuánto has deslizado (así también se activan la primera y la última)
    let centerId = null;
    function onScroll() {
      if (fine.matches || !hots.length) return;
      const max = scroller.scrollWidth - scroller.clientWidth;
      const prog = max > 0 ? scroller.scrollLeft / max : 0;
      const best = Math.min(hots.length - 1, Math.max(0, Math.round(prog * (hots.length - 1))));
      const id = hots[best].dataset.id;
      if (id === centerId) return; centerId = id;
      hots.forEach((h, i) => h.classList.toggle('is-center', i === best));
      [...(dotsEl?.children || [])].forEach((d, i) => d.classList.toggle('on', i === best));
      if (litLoaded && !isNight()) slices.forEach(sl => sl.classList.toggle('on', sl.dataset.id === id));
    }
    scroller.addEventListener('scroll', () => requestAnimationFrame(onScroll), { passive: true });
    addEventListener('resize', () => { centerId = null; onScroll(); });
    onScroll();

    // Entrar en una tienda: zoom dentro de la foto y se abre su página
    function enter(h) {
      const l = num(h, 'l'), t = num(h, 't'), w = num(h, 'w'), hh = num(h, 'h');
      canvas.style.setProperty('--ox', `${l + w / 2}%`); canvas.style.setProperty('--oy', `${t + hh * .8}%`);
      sliceOf(h.dataset.id)?.classList.add('on'); canvas.classList.add('is-entering');
      setTimeout(() => { location.href = h.href; }, 620);
    }
    // Al volver atrás (caché del navegador), la calle aparece normal, no ampliada
    addEventListener('pageshow', e => { if (e.persisted) { canvas.classList.remove('is-entering'); if (!isNight()) slices.forEach(sl => sl.classList.remove('on')); } });
    return { setStreet, enter, box };
  }

  // ---------- RAYOS X: se anima al activarlo, sin secuestrar el scroll ----------
  let X = null;
  function initXray() {
    const xr = $('#rayos-x'); if (!xr) return null;
    const sw = $('#xswitch'), dev = $('#device'), layers = $$('.layer', xr), cards = $$('.rc', xr), lab = $('.scene', xr);
    let xOn = false, played = false;
    function setX(on) {
      xOn = on; xr.classList.toggle('is-on', on); sw.setAttribute('aria-pressed', String(on));
      const hint = $('#xhint'); if (hint) hint.textContent = on ? T.pista_on : T.pista_off;
      if (!on) focusLayer(-1);
    }
    function focusLayer(i) {
      layers.forEach(l => l.classList.toggle('is-focus', +l.dataset.layer === i));
      dev.classList.toggle('has-focus', i >= 0);
      cards.forEach(c => c.classList.toggle('is-focus', +c.dataset.step === i));
    }
    // el bloque desmontado mide ≈ 640 px a escala 1: se ajusta para que quepa entero en la pantalla
    function fitX() {
      const avail = Math.min(innerHeight - 110, 700), s0 = Math.max(.5, Math.min(1, avail / 640, (lab.clientWidth || innerWidth) / 520));
      dev.style.setProperty('--s0', s0.toFixed(3)); lab.style.setProperty('--scene-h', Math.round(Math.max(460, avail)) + 'px');
    }
    fitX(); addEventListener('resize', fitX);
    function playX(on) {
      const r = lab.getBoundingClientRect(), visible = r.top > -40 && r.bottom < innerHeight + 40;
      if (on && !visible) { lab.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); setTimeout(() => setX(true), reduce ? 0 : 500); }
      else setX(on);
    }
    sw.addEventListener('click', () => { played = true; playX(!xOn); });
    new IntersectionObserver((es, io) => es.forEach(e => { if (e.isIntersecting && !played) { played = true; setTimeout(() => setX(true), 350); io.disconnect(); } }), { threshold: .5 }).observe(lab);
    const mine = $('#mine');
    mine?.addEventListener('submit', e => {
      e.preventDefault(); const u = $('#mine-url').value.trim();
      if (!u) { toast(T.la_mia_vacia); return; }
      // Decisión 58 A (06/10/2026): no hay análisis automático; bajamos al formulario con su web ya puesta y la miro yo.
      const q = $('#q-store'), msg = $('#q-msg'), need = $('#q-need'), mail = $('#q-email'), box = $('#presupuesto');
      if (q) q.value = u;
      if (msg && !msg.value) msg.value = (T.la_mia_msg || '').replace('{url}', u);
      if (need && need.options.length) need.selectedIndex = need.options.length - 1;
      toast(T.la_mia.replace('{url}', u));
      if (box) { box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); setTimeout(() => mail?.focus({ preventScroll: true }), reduce ? 0 : 700); }
    });
    const pick = (c, e) => { if (e.target.closest('a')) return; if (!xOn) setX(true); focusLayer(+c.dataset.step); };
    cards.forEach(c => c.addEventListener('click', e => pick(c, e)));
    cards.forEach(c => c.addEventListener('keydown', e => { if ((e.key === 'Enter' || e.key === ' ') && !e.target.closest('a')) { e.preventDefault(); pick(c, e); } }));
    return { setX };
  }

  // ---------- Clics: tiendas de la calle, lista, menú, avisos ----------
  const menu = $('#menu'), menuBtn = $('#menu-btn');
  menu && menu.addEventListener('focusout', e => { if (!menu.hidden && !menu.contains(e.relatedTarget) && e.relatedTarget !== menuBtn) closeMenu(); });
  function closeMenu() { if (!menu) return; menu.hidden = true; menuBtn.setAttribute('aria-expanded', 'false'); menuBtn.textContent = T.menu; }
  menuBtn?.addEventListener('click', () => { const open = menu.hidden; menu.hidden = !open; menuBtn.setAttribute('aria-expanded', String(open)); menuBtn.textContent = open ? T.cerrar : T.menu; });
  function goTo(id) {
    const el = document.getElementById(id); if (!el) return false;
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
    if (id === 'rayos-x' && X) setTimeout(() => X.setX(true), 600);
    return true;
  }
  document.addEventListener('click', e => {
    const opener = e.target.closest('.hot, .list a');
    if (opener && street && street.box.contains(opener) && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button)) {
      closeMenu();
      if (opener.dataset.scroll) { if (goTo(opener.dataset.scroll)) e.preventDefault(); return; }
      if (opener.classList.contains('hot') && !reduce) { e.preventDefault(); street.enter(opener); }
      return;
    }
    const d = e.target.closest('[data-demo]');
    if (d) toast(d.dataset.demo);
    if (e.target.closest('#menu a')) closeMenu();
  });
  addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });

  // ---------- Página de servicio: precio de la opción elegida y foto del escaparate ----------
  /* Galería de la ficha: las flechas mueven una foto (el carrusel también se desliza con el dedo, el ratón o el teclado) */
  $$('[data-galeria]').forEach(g => {
    const lista = $('.galeria__lista', g);
    $$('[data-galeria-paso]', g).forEach(b => b.addEventListener('click', () => {
      const item = $('.galeria__item', lista);
      if (item) lista.scrollBy({ left: +b.dataset.galeriaPaso * (item.getBoundingClientRect().width + 12), behavior: reduce ? 'auto' : 'smooth' });
    }));
    /* 09/10/2026 (Adrián): las fotos pasan solas cada 4 s y al final vuelven a la primera. Se paran con el ratón o el foco
       encima, 8 s después de que el cliente las mueva, fuera de la pantalla, con la foto en grande abierta y con el botón
       de pausa (WCAG 2.2.2). Quietas con «Reducir movimiento». */
    const items = $$('.galeria__item', lista), flechas = $('.galeria__flechas', g);
    if (reduce || items.length < 2 || !flechas) return;
    let pausa = false, dentro = false, visto = false, ultimo = 0;
    const pb = document.createElement('button');
    pb.type = 'button'; pb.className = 'galeria__flecha';
    const pintar = () => { pb.textContent = pausa ? '▶' : '❚❚'; pb.setAttribute('aria-pressed', pausa); pb.setAttribute('aria-label', pausa ? 'Reanudar el paso de las fotos' : 'Pausar el paso de las fotos'); };
    pb.addEventListener('click', () => { pausa = !pausa; pintar(); });
    pintar(); flechas.appendChild(pb);
    const toca = () => { ultimo = Date.now(); };
    ['pointerdown', 'wheel', 'keydown'].forEach(ev => lista.addEventListener(ev, toca, { passive: true }));
    $$('[data-galeria-paso]', g).forEach(b => b.addEventListener('click', toca));
    lista.addEventListener('mouseenter', () => { dentro = true; });
    lista.addEventListener('mouseleave', () => { dentro = false; });
    g.addEventListener('focusin', e => { if (e.target !== pb) dentro = true; });
    g.addEventListener('focusout', e => { if (!g.contains(e.relatedTarget)) dentro = false; });
    if ('IntersectionObserver' in window) new IntersectionObserver(es => { visto = es[0].isIntersecting; }, { threshold: .5 }).observe(lista); else visto = true;
    setInterval(() => {
      if (pausa || dentro || !visto || document.hidden || Date.now() - ultimo < 8000 || $('#zoom')?.open) return;
      const fin = lista.scrollLeft + lista.clientWidth >= lista.scrollWidth - 4;
      if (fin) lista.scrollTo({ left: 0, behavior: 'smooth' });
      else lista.scrollBy({ left: items[0].getBoundingClientRect().width + 12, behavior: 'smooth' });
    }, 4000);
  });
  /* Foto en grande: al pulsar una imagen de la galería se abre a pantalla completa (flechas, teclado y Esc) */
  const zoom = $('#zoom');
  if (zoom) {
    const zbtn = $$('[data-zoom]'), zimg = $('.zoom__img', zoom), zcnt = $('.zoom__n', zoom); let zi = 0;
    const marco = $('[data-zoom-marco]', zoom), acercar = $('[data-zoom-acercar]', zoom);
    // Acercar (x2,5) y recorrer la foto con el ratón o el dedo; se quita al cambiar de foto
    const cerca = (on, e) => { marco.classList.toggle('is-cerca', on); acercar?.setAttribute('aria-pressed', on); if (!on) zimg.style.transformOrigin = ''; else if (e) origen(e); };
    const origen = e => { const r = marco.getBoundingClientRect(); zimg.style.transformOrigin = Math.min(100, Math.max(0, (e.clientX - r.left) / r.width * 100)) + '% ' + Math.min(100, Math.max(0, (e.clientY - r.top) / r.height * 100)) + '%'; };
    marco?.addEventListener('click', e => cerca(!marco.classList.contains('is-cerca'), e));
    marco?.addEventListener('pointermove', e => { if (marco.classList.contains('is-cerca')) origen(e); });
    acercar?.addEventListener('click', () => cerca(!marco.classList.contains('is-cerca')));
    const zshow = i => { cerca(false); zi = (i + zbtn.length) % zbtn.length; const b = zbtn[zi]; zimg.src = b.dataset.zoom; zimg.alt = b.dataset.alt || ''; if (zcnt) zcnt.textContent = (zi + 1) + ' / ' + zbtn.length; };
    zbtn.forEach((b, i) => b.addEventListener('click', () => { zshow(i); zoom.showModal(); }));
    $$('[data-zoom-paso]', zoom).forEach(b => b.addEventListener('click', () => zshow(zi + +b.dataset.zoomPaso)));
    $('.zoom__cerrar', zoom)?.addEventListener('click', () => zoom.close());
    zoom.addEventListener('click', e => { if (e.target === zoom) zoom.close(); });
    zoom.addEventListener('keydown', e => { if (e.key === 'ArrowRight') zshow(zi + 1); if (e.key === 'ArrowLeft') zshow(zi - 1); });
    zoom.addEventListener('close', () => zbtn[zi]?.focus());
    // Lupa al pasar el ratón (solo con ratón): la foto se amplía donde está el cursor, con la versión de 2048 px
    if (matchMedia('(hover: hover) and (pointer: fine)').matches) zbtn.forEach(b => {
      const img = $('.galeria__img', b); if (!img) return;
      const mover = e => { const r = b.getBoundingClientRect(); img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; };
      b.addEventListener('pointerenter', e => {
        if (e.pointerType !== 'mouse') return;
        if (!img.dataset.grande) { img.dataset.grande = '1'; const g = new Image(); g.onload = () => { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = b.dataset.zoom; }; g.src = b.dataset.zoom; }
        mover(e); b.classList.add('is-lupa');
      });
      b.addEventListener('pointermove', e => { if (e.pointerType === 'mouse') mover(e); });
      b.addEventListener('pointerleave', () => b.classList.remove('is-lupa'));
    });
  }
  // Opciones a la vista (tarjetas con radio): el precio grande sigue a la opción elegida
  $('#ficha-opciones')?.addEventListener('change', (e) => { const p = $('#ficha-precio'); if (e.target.name === 'id' && p) p.textContent = e.target.dataset.precio; });
  if (window.fichaPlace) addEventListener('resize', window.fichaPlace);
  function setFicha(night) {
    const im = $('#ficha-hero img'); if (!im) return;
    const src = night ? im.dataset.night : im.dataset.day;
    const s = im.parentElement.querySelector('source'); if (s) s.srcset = src;
    im.src = src;
  }

  // ---------- Datos en vivo de esta página ----------
  const setM = (k, v) => $$(`[data-m="${k}"]`).forEach(el => el.textContent = v);
  let lcp = 0, cls = 0;
  function showLcp() { const s = lcp / 1000; setM('lcp', `${fmt(s, 2)} s`); $('#usbar')?.style.setProperty('--v', s.toFixed(2)); $('.gauge i')?.style.setProperty('--g', `${Math.max(8, Math.min(100, 100 - (s - 1) / 4 * 100)).toFixed(0)}%`); }
  try {
    new PerformanceObserver(l => { const e = l.getEntries().at(-1); if (e) { lcp = e.startTime; showLcp(); } }).observe({ type: 'largest-contentful-paint', buffered: true });
    new PerformanceObserver(l => { for (const e of l.getEntries()) if (!e.hadRecentInput) cls += e.value; setM('cls', fmt(cls, 3)); }).observe({ type: 'layout-shift', buffered: true });
    new PerformanceObserver(l => { const f = l.getEntries().find(e => e.name === 'first-contentful-paint'); if (f) setTimeout(() => { if (!lcp) { lcp = f.startTime; showLcp(); } }, 1500); }).observe({ type: 'paint', buffered: true });
  } catch (_) {}
  setM('cls', fmt(0, 3));
  onLoad(() => setTimeout(() => {
    const res = performance.getEntriesByType('resource'), nav = performance.getEntriesByType('navigation')[0];
    const bytes = res.reduce((a, r) => a + (r.transferSize || 0), nav?.transferSize || 0);
    setM('kb', bytes ? `${fmt(bytes / 1024, 0)} KB` : T.cache); setM('req', String(res.length + 1));
  }, 400));
  const lum = hex => { const c = hex.match(/\w\w/g).map(x => parseInt(x, 16) / 255).map(v => v <= .03928 ? v / 12.92 : ((v + .055) / 1.055) ** 2.4); return .2126 * c[0] + .7152 * c[1] + .0722 * c[2]; };
  const cr = (a, b) => { const [x, y] = [lum(a), lum(b)].sort((m, n) => n - m); return (x + .05) / (y + .05); };
  setM('contrast', `${fmt(cr('16150F', 'FFFFFF'), 1)}:1`);

  // Soporte abierto o cerrado según la hora de Madrid (L-V, horario de los ajustes del tema)
  const status = $('#status-foot');
  if (status) {
    const now = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', weekday: 'short', hour: 'numeric', hour12: false }).formatToParts(new Date());
    const h = +now.find(p => p.type === 'hour').value % 24, wd = now.find(p => p.type === 'weekday').value;
    const [ini, fin] = W.horario || [9, 19];
    status.textContent = (!/Sat|Sun/.test(wd) && h >= ini && h < fin) ? T.abierto : T.cerrado;
  }

  // ---------- Selector Día / Noche ----------
  const btns = $$('[data-theme-set]');
  const cambia = $$('[data-tema-cambia]'); // botón ☀/☾ de la cabecera (rediseño 16/10/2026)
  const markTheme = () => { const t = isNight() ? 'dark' : 'light'; btns.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.themeSet === t))); cambia.forEach(b => b.setAttribute('aria-pressed', String(t === 'dark'))); };
  const applyImages = () => { street?.setStreet(isNight()); setFicha(isNight()); };
  btns.forEach(b => b.addEventListener('click', () => vt(() => {
    root.dataset.theme = b.dataset.themeSet; try { localStorage.setItem('web-estilo', b.dataset.themeSet); } catch (_) {}
    markTheme(); applyImages();
  })));
  cambia.forEach(b => b.addEventListener('click', () => vt(() => {
    const t = isNight() ? 'light' : 'dark';
    root.dataset.theme = t; root.dataset.elegido = '1'; try { localStorage.setItem('web-estilo', t); } catch (_) {}
    markTheme(); applyImages();
  })));
  sysDark.addEventListener('change', () => { markTheme(); if (!root.dataset.theme) applyImages(); });
  markTheme();

  // ---------- Arranque (y de nuevo si el editor de temas recarga una sección) ----------
  street = initStreet(); X = initXray();
  if (root.dataset.elegido) applyImages(); // el visitante eligió Día/Noche en otra visita
  /* Fotos de las tarjetas. 13/10/2026 (Adrián): ya NO cambian solas en ninguna página (portada y catálogo); cambian solo
     con el ratón: al entrar, la siguiente, y mientras sigue encima, otra cada 1,5 s. Las tarjetas de Temas de la portada
     las mueve su carrusel (claro → oscuro → siguiente tema, en sections/temas-portada.liquid) con window.fotoTarjeta. */
  const cargarFoto = img => new Promise(ok => {
    if (!img.dataset.src) return ok();
    img.onload = img.onerror = () => ok(); img.srcset = img.dataset.srcset; img.src = img.dataset.src; delete img.dataset.src;
  });
  // Enseña la foto k de una caja [data-fotos] (la carga antes); guarda en data-i cuál se ve.
  window.fotoTarjeta = async (caja, k) => {
    const imgs = $$('img', caja); if (imgs.length < 2) return;
    const actual = +(caja.dataset.i || 0), sig = ((k % imgs.length) + imgs.length) % imgs.length;
    if (sig === actual && caja.classList.contains('is-js')) return;
    await cargarFoto(imgs[sig]);
    if (!caja.classList.contains('is-js')) { caja.classList.add('is-js'); imgs[actual].classList.add('is-on'); }
    imgs.forEach((im, n) => im.classList.toggle('is-on', n === sig)); caja.dataset.i = sig;
  };
  const initFotos = (raiz = document) => {
    $$('[data-fotos]', raiz).forEach(caja => {
      if (caja.dataset.fotosOn) return; caja.dataset.fotosOn = '1';
      if ($$('img', caja).length < 2) return;
      const tarjeta = caja.closest('.tarjeta') || caja;
      const pasar = () => window.fotoTarjeta(caja, +(caja.dataset.i || 0) + 1);
      let t = null;
      tarjeta.addEventListener('mouseenter', () => { pasar(); clearInterval(t); t = setInterval(pasar, 1500); });
      tarjeta.addEventListener('mouseleave', () => { clearInterval(t); t = null; });
    });
  };
  initFotos();
  document.addEventListener('shopify:section:load', e => initFotos(e.target));
  document.addEventListener('shopify:section:load', e => {
    if ($('#canvas', e.target)) street = initStreet();
    if ($('#rayos-x', e.target)) X = initXray();
  });
})();

/* 15/10/2026: mientras el aviso de cookies de Shopify está abierto, las barras fijas de abajo (.vb) se colocan encima de él
   en vez de quedar tapadas. --banner-h = alto del aviso visible (0 cuando el visitante ya ha elegido). */
(function(){
  var raiz=document.documentElement,visto=null;
  function medir(){var e=document.getElementById('shopify-pc__banner'),h=0;
    if(e&&e.offsetHeight&&getComputedStyle(e).display!=='none'&&getComputedStyle(e).visibility!=='hidden')h=e.offsetHeight;
    raiz.style.setProperty('--banner-h',h+'px');
    if(e&&e!==visto){visto=e;cuerpo.disconnect();new MutationObserver(medir).observe(e,{attributes:true,attributeFilter:['style','class','hidden']});}}
  var cuerpo=new MutationObserver(medir);cuerpo.observe(document.body,{childList:true,subtree:true});
  addEventListener('resize',medir,{passive:true});document.addEventListener('visitorConsentCollected',function(){setTimeout(medir,50)});
  medir();
})();
